// import { defaultLocale, localeOptions } from '../../constants/defaultValues'

import {
	LOGOUT_USER,

	// Queue Management
	QUEUE_MANAGEMENT_LOAD_QUEUE_BY_DATE,
	QUEUE_MANAGEMENT_LOAD_QUEUE_BY_DATE_SUCCESS,
	QUEUE_MANAGEMENT_CREATE_QUEUE,
	QUEUE_MANAGEMENT_UPDATE_QUEUE,
	QUEUE_MANAGEMENT_DELETE_QUEUE,

	// QUEUE_MANAGEMENT_LOAD_POSITION,
	// QUEUE_MANAGEMENT_LOAD_POSITION_SUCCESS,
	// QUEUE_MANAGEMENT_CREATE_POSITION,
	// QUEUE_MANAGEMENT_UPDATE_POSITION,
	// QUEUE_MANAGEMENT_DELETE_POSITION,

	// QUEUE_MANAGEMENT_LOAD_STAFF,
	// QUEUE_MANAGEMENT_LOAD_STAFF_SUCCESS,
	// QUEUE_MANAGEMENT_CREATE_STAFF,
	// QUEUE_MANAGEMENT_UPDATE_STAFF,
	// QUEUE_MANAGEMENT_DELETE_STAFF,
	// END Queue Management


} from '../actions';

const INIT_STATE = {

	queue: [],
	optionQueue: [],

	// position: [],
	// optionPosition: [],

	// staff: [],
	// optionStaff: [],

	queueLoading: false,
	// positionLoading: false,
	// staffLoading: false,

};

export default (state = INIT_STATE, action) => {
	switch (action.type) {

		case QUEUE_MANAGEMENT_LOAD_QUEUE_BY_DATE:
			return { ...state, queueLoading: true }
		case QUEUE_MANAGEMENT_LOAD_QUEUE_BY_DATE_SUCCESS:
			return {
				...state,
				queueLoading: false,
				queue: action.payload,
				optionQueue: action.payloadlist
			}
		case QUEUE_MANAGEMENT_CREATE_QUEUE:
			return { ...state, queueLoading: true }
		case QUEUE_MANAGEMENT_UPDATE_QUEUE:
			return { ...state, queueLoading: true }
		case QUEUE_MANAGEMENT_DELETE_QUEUE:
			return { ...state, queueLoading: true }

		// case QUEUE_MANAGEMENT_LOAD_POSITION:
		// 	return { ...state, positionLoading: true }
		// case QUEUE_MANAGEMENT_LOAD_POSITION_SUCCESS:
		// 	return {
		// 		...state,
		// 		positionLoading: false,
		// 		position: action.payload,
		// 		optionPosition: action.payloadlist
		// 	}
		// case QUEUE_MANAGEMENT_CREATE_POSITION:
		// 	return { ...state, positionLoading: true }
		// case QUEUE_MANAGEMENT_UPDATE_POSITION:
		// 	return { ...state, positionLoading: true }
		// case QUEUE_MANAGEMENT_DELETE_POSITION:
		// 	return { ...state, positionLoading: true }

		// case QUEUE_MANAGEMENT_LOAD_STAFF:
		// 	return { ...state, staffLoading: true }
		// case QUEUE_MANAGEMENT_LOAD_STAFF_SUCCESS:
		// 	return {
		// 		...state,
		// 		staffLoading: false,
		// 		staff: action.payload,
		// 		optionStaff: action.payloadlist
		// 	}
		// case QUEUE_MANAGEMENT_CREATE_STAFF:
		// 	return { ...state, staffLoading: true }
		// case QUEUE_MANAGEMENT_UPDATE_STAFF:
		// 	return { ...state, staffLoading: true }
		// case QUEUE_MANAGEMENT_DELETE_STAFF:
		// 	return { ...state, staffLoading: true }

		case LOGOUT_USER:
			return {
				...state,
				queue: [],
				optionQueue: [],

				// position: [],
				// optionPosition: [],

				// staff: [],
				// optionStaff: [],

				queueLoading: false,
				// positionLoading: false,
				// staffLoading: false,
			};

		default: return { ...state };
	}
}